import React, { useEffect } from 'react'
import useSpeechVolumeLevel from '../hooks/useSpeechVolumeLevel'
import './VolumeMeter.scss'
import VolumeMeterBar from './VolumeMeterBar'
import cx from 'classnames'

export default React.memo(function VolumeMeter({speechProps, getVolumeStats, shouldStartVolumeProcessing}){

    const { volumeLevel } = useSpeechVolumeLevel({speechProps, shouldStartVolumeProcessing})
    
    useEffect(()=>{

        if(getVolumeStats && volumeLevel){
            if(Object.keys(volumeLevel).length){
                getVolumeStats(volumeLevel)
            }
        }

    }, [volumeLevel])

    const {  db, softThreshold } = volumeLevel // instant, db, slow, soft, loud, clip, loudThreshold, softThreshold
    
    if(!db) return null
    let meterValue = db - (softThreshold * 1.35) // the constant is to make it close to a positive number so we display a few bars when volume is soft
    if( meterValue <= 0 ) return null

    const barCount = meterValue.toFixed(0)
    const barsArray = new Array(20)
    const bars = barsArray.fill(VolumeMeterBar)
    
    const classes = cx({
        'volume-meter': true,
    })
    return <div className={classes}>
        {bars.map( (Bar, i) => <Bar barCount={barCount} volumeStats={volumeLevel} index={20 - i} key={i}/>)}
    </div>
})